import dynamic from 'next/dynamic';

const B2BOrdersGrid = dynamic(() => import('./B2BOrdersGrid/B2BOrdersGrid'));
const B2BOrderBookingsGrid = dynamic(() =>
  import('./B2BOrderBookingsGrid/B2BOrderBookingsGrid')
);
const B2BOrderBookingsFilters = dynamic(() =>
  import('./B2BOrderBookingsFilters/B2BOrderBookingsFilters')
);
const B2BAddOrder = dynamic(() => import('./B2BAddOrder/B2BAddOrder'));
const B2BEditOrder = dynamic(() => import('./B2BEditOrder/B2BEditOrder'));

export {
  B2BOrdersGrid,
  B2BOrderBookingsGrid,
  B2BOrderBookingsFilters,
  B2BAddOrder,
  B2BEditOrder,
};
